import styled from 'styled-components';

import { theme } from './GlobalStyles';

const Level1 = styled.ol`
  list-style-type: none;
  counter-reset: item;
  margin: 0;
  padding: 0;
  font-weight: bold;
  li {
    display: table;
    counter-increment: item;
    margin-bottom: 0.6rem;
  }
  > li:before {
    display: inline-block;
    padding-right: 0.6rem;
    content: counters(item, '.') '. ';
  }
`;
const Level2 = styled.ol`
  font-weight: normal;
  list-style-type: none;
  counter-reset: item;
  margin: 0.6rem 0;
  padding: 0;
  > li:before {
    content: counters(item, '.') ' ';
    display: table-cell;
    padding-right: 0.6rem;
  }
  li {
    margin: 0.6rem 0;
  }
  ${theme.mediaQueries.above.small} {
    padding-left: 1.5rem;
  }
`;
const Level3 = styled.ol`
  font-weight: normal;
  list-style-type: lower-alpha;
  counter-reset: none;
  padding-left: 1rem;
  li {
    display: list-item;
    counter-increment: none;
    padding-left: 0.6rem;
  }
  ${theme.mediaQueries.above.small} {
    padding-left: 1.5rem;
  }
`;
const Level4 = styled.ol`
  font-weight: normal;
  list-style-type: lower-roman;
  list-style-position: inside;
  margin: 0;
  > li {
    margin: 0.6rem 0;
  }
`;

export { Level1, Level2, Level3, Level4 };
